import { withFormik } from 'formik';
import { RouteComponentProps, withRouter } from 'react-router';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import { History } from 'history';
import { AppThunk } from '../../app/store';
import {
  ABOUT_REQUIRED,
  ADDRESS_REQUIRED,
  CITY_REQUIRED,
  COUNTRY_REQUIRED,
  EMAIL_INVALID,
  EMAIL_NOT_LONG_ENOUGH,
  EMAIL_REQUIRED,
  NAME_REQUIRED,
  POSTAL_CODE_REQUIRED,
  REFERENCE_CODE_REQUIRED,
  SCHOOL_NAME_REQUIRED,
  STREET_REQUIRED,
} from '../../constants/formMessages';
import { AddOrEditRecipeImagesForm } from './AddOrEditRecipeImagesForm';
import { createRecipe } from '../../slices/recipeSlice';

interface IDispatchProps {
    
    createRecipe: (
    recipeUrl: string,
    recipeTitle: string,
    recipeDescription: string,
    TypeOfRecipe: string,
    tags: string[],
    preparationTime: string,
    userId: string,
    history: History
  ) => AppThunk;
}

export interface EnhancedAddOrEditRecipeImagesFormValues {
    recipeUrl: string;
    recipeTitle: string;
    recipeDescription: string;
    TypeOfRecipe: string,
    tags: string[];
    preparationTime: string;
    userId: string;
}

export interface EnhancedAddOrEditRecipeImagesFormProps extends RouteComponentProps {
    recipeUrl?: string;
    recipeTitle?: string;
    recipeDescription?: string;
    TypeOfRecipe?: string;
    tags?: string[];
    preparationTime?: string;
    userId?: string;
  createRecipe: (
    recipeUrl: string,
    recipeTitle: string,
    recipeDescription: string,
    TypeOfRecipe: string,
    tags: string[],
    preparationTime: string,
    userId: string,
     history: History
  ) => void;
}

const EnhancedAddOrEditRecipeImagesForm = withFormik<
  EnhancedAddOrEditRecipeImagesFormProps,
  EnhancedAddOrEditRecipeImagesFormValues
>({
  mapPropsToValues: (props) => ({
    recipeUrl: props.recipeUrl ? props.recipeUrl : '',
    recipeTitle: props.recipeTitle ? props.recipeTitle : '',
    recipeDescription: props.recipeDescription ? props.recipeDescription : '',
    TypeOfRecipe: props.TypeOfRecipe ? props.TypeOfRecipe : '',
    tags: props.tags ? props.tags : [],
    preparationTime: props.preparationTime ? props.preparationTime : '',
    userId: props.userId ? props.userId : '',
   
  }),
  validationSchema: Yup.object().shape({
    recipeUrl: Yup.string().notRequired(),
    recipeTitle: Yup.string().required(NAME_REQUIRED),
    recipeDescription: Yup.string().notRequired(),
    TypeOfRecipe: Yup.string().notRequired(),
    tags: Yup.array().of(Yup.string()),
    preparationTime: Yup.string().notRequired(),
    userId: Yup.string().notRequired(),
    // city: Yup.string().notRequired(),
    // country: Yup.string().notRequired(),
    // postalCode: Yup.number().notRequired(),
    // about: Yup.string().notRequired(),
    // diagnoses: Yup.array().of(Yup.string()),
    // counselors: Yup.array().of(Yup.string()),
  }),
  handleSubmit: (values, { setSubmitting, props }) => {
    const { history, createRecipe } = props;
    const {
        recipeUrl,
        recipeTitle,
        recipeDescription,
        TypeOfRecipe,
        tags,
        preparationTime,
        userId
    } = values;
    createRecipe(
         recipeUrl,
        recipeTitle,
        recipeDescription,
        TypeOfRecipe,
        tags,
        preparationTime,
        userId,
        history
    );
    setSubmitting(false);
  },
  displayName: 'BasicForm',
})(AddOrEditRecipeImagesForm);

const EnhancedAddOrEditRecipeImagesFormWithRouter = withRouter(
  EnhancedAddOrEditRecipeImagesForm
);

export default connect<null, IDispatchProps>(null, {
    createRecipe,
})(EnhancedAddOrEditRecipeImagesFormWithRouter);
